import { useState, useEffect } from "react";

const useChangeBlockListByPenalize = ({
    penaltyTypeId,
    blockList,
    changeBlockId, isUpdate
}) => {
    //#region States
    const [blockListFiltered, setBlockListFiltered] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        setBlockListFiltered(blockList.filter(item => item.penalizeId === penaltyTypeId));
    }, [penaltyTypeId]);
    useEffect(() => {
        if (blockListFiltered.length > 0 || isUpdate) return;
        changeBlockId(0);
    },[blockListFiltered]);
    //#endregion
    return {
        blockListFiltered
    };
}

export default useChangeBlockListByPenalize;